import bridge from "@/api/bridge";
import version from "@/../public/version.json";

export const isNativeApp = () => typeof window.ReactNativeWebView === "object";

let $environment = null;
export function getEnvironment() {
	if ($environment) {
		return $environment;
	} else if (
		// production builds deployed to cloud
		location.href.indexOf("ops-dev.k4connect.com") > -1 ||
		location.href.indexOf("localhost") > -1 ||
		location.href.indexOf(".local") > -1
	) {
		$environment = "development";
	} else if (location.href.indexOf("ops-staging.k4connect.com") > -1) {
		$environment = "staging";
	} else if (location.href.indexOf("ops.k4connect.com") > -1) {
		$environment = "production";
	} else {
		// else set from webpack / vue cli
		$environment = process.env.NODE_ENV;
	}
	return $environment;
}

export const getWebVersion = () => version.version;

let $appVersion = null;
export async function getAppVersion() {
	if ($appVersion) return $appVersion;

	if (!isNativeApp()) {
		$appVersion = "N/A";
	} else {
		try {
			$appVersion = await bridge.appVersion();
		} catch (e) {
			window.vm.$bugsnagClient.notify(e);
			window.vm.$log(`Failed to retrieve native app version`);
			$appVersion = "Unknown";
		}
	}
	return $appVersion;
}
